import i18next from "../i18n/config";

export const getGeneralQuestions = () => {
  return [
    {
      question: i18next.t("generalQuestions.question1"),
      answer: i18next.t("generalQuestions.answer1"),
    },
    {
      question: i18next.t("generalQuestions.question2"),
      answer: i18next.t("generalQuestions.answer2"),
    },
    {
      question: i18next.t("generalQuestions.question3"),
      answer: i18next.t("generalQuestions.answer3"),
    },
    {
      question: i18next.t("generalQuestions.question4"),
      answer: i18next.t("generalQuestions.answer4"),
    },
    {
      question: i18next.t("generalQuestions.question5"),
      answer: i18next.t("generalQuestions.answer5"),
    },
  ];
};
